import { ActionType, ChildActionType } from '@editor/src/js/constants/common-action-type';
import * as chartConfig from '@framework/workbench/ui/chart/config';
import { WorkbenchMenuSchema } from '@tencent/workbench';
import { wrapIdForBig, wrapIdForTopMenuHor } from '@framework/workbench/util/wrap-id-util';
import { ToolbarType } from '@src/js/constant';
import { IMMERSIVE_TOGGLE } from '@framework/workbench/ui/toggle/config';
import * as insertPictureConfig from '@framework/workbench/ui/insert/insert-picture/config';
import * as insertAudioConfig from '@framework/workbench/ui/insert/insert-audio/config';
import * as insertVideoConfig from '@framework/workbench/ui/insert/insert-video/config';
import { FileMenuKey } from '@tencent/docs-titlebar-service';

export const PREFIX = 'workbench-top-menu-';

export const DIVIDER = 'divider';

export const MenuKey = {
    LOCAL_FILE_SAVE_AS: 'local-file-save-as',
    LOCAL_FILE_SAVE: 'local-file-save',
    LOCAL_FILE_FOLDER: 'local-file-folder',
    FILE: 'file',
    FILE_INFO: 'file-info',
    HIGHLIGHT_TITLE: 'highlight-title',
    ANONYMOUS_VIEW: 'anonymous_view',
    EDIT: 'edit',

    ADD_GROUP: `${PREFIX}${ActionType.ADDGROUP}`,
    REMOVE_GROUP: `${PREFIX}${ActionType.REMOVEGROUP}`,

    ALIGN: `${PREFIX}${ActionType.ALIGN}`,
    ALIGN_HORIZONTAL_LEFT: `${PREFIX}${ActionType.ALIGN_HORIZONTALLT_LEFT}`,
    ALIGN_HORIZONTAL_CENTER: `${PREFIX}${ActionType.ALIGN_HORIZONTALLT_CENTER}`,
    ALIGN_HORIZONTAL_RIGHT: `${PREFIX}${ActionType.ALIGN_HORIZONTALLT_RIGHT}`,
    ALIGN_VERTICALLY_TOP: `${PREFIX}${ActionType.ALIGN_VERTICALLY_TOP}`,
    ALIGN_VERTICALLY_CENTER: `${PREFIX}${ActionType.ALIGN_VERTICALLY_CENTER}`,
    ALIGN_VERTICALLY_BOTTOM: `${PREFIX}${ActionType.ALIGN_VERTICALLY_BOTTOM}`,
    ALIGN_DISTRIBUTE_HORIZONTAL: `${PREFIX}${ActionType.ALIGN_DISTRIBUTE_HORIZONTALLT}`,
    ALIGN_DISTRIBUTE_VERTICALLY: `${PREFIX}${ActionType.ALIGN_DISTRIBUTE_VERTICALLY}`,

    TAILOR_PIC_SHAPE_CONTAINER: 'tailor-pic-shape-container',
    TAILOR_PIC_WH: `${PREFIX}${ActionType.TAILOR_PIC_WH}`,
    TAILOR_PIC_WH_1_1: `${PREFIX}${ActionType.TAILOR_PIC_WH_1_1}`,
    TAILOR_PIC_WH_2_3: `${PREFIX}${ActionType.TAILOR_PIC_WH_2_3}`,
    TAILOR_PIC_WH_3_4: `${PREFIX}${ActionType.TAILOR_PIC_WH_3_4}`,
    TAILOR_PIC_WH_3_5: `${PREFIX}${ActionType.TAILOR_PIC_WH_3_5}`,
    TAILOR_PIC_WH_4_5: `${PREFIX}${ActionType.TAILOR_PIC_WH_4_5}`,
    TAILOR_PIC_WH_3_2: `${PREFIX}${ActionType.TAILOR_PIC_WH_3_2}`,
    TAILOR_PIC_WH_4_3: `${PREFIX}${ActionType.TAILOR_PIC_WH_4_3}`,
    TAILOR_PIC_WH_5_3: `${PREFIX}${ActionType.TAILOR_PIC_WH_5_3}`,
    TAILOR_PIC_WH_5_4: `${PREFIX}${ActionType.TAILOR_PIC_WH_5_4}`,
    TAILOR_PIC_WH_16_9: `${PREFIX}${ActionType.TAILOR_PIC_WH_16_9}`,
    TAILOR_PIC_WH_16_10: `${PREFIX}${ActionType.TAILOR_PIC_WH_16_10}`,

    SLIDE_SIZE: `${PREFIX}${ActionType.SLIDE_SIZE}`,
    SLIDE_STANDARD: `${PREFIX}${ActionType.SLIDE_STANDARD}`,
    SLIDE_WIDE: `${PREFIX}${ActionType.SLIDE_WIDE}`,

    // 右上角菜单 顶部横向菜单项
    OPERATION_HOR_MENU: 'operation-hor-menu',
    OPEN_CLIENT_HOR: FileMenuKey.OPEN_CLIENT,
    EXPORT_HOR: wrapIdForTopMenuHor('export'),
    PRINT_HOR: wrapIdForTopMenuHor('print'),
    GENERATE_COPIES_HOR: wrapIdForTopMenuHor('generate_copies'),

    RENAME: `${PREFIX}_rename`,
    PRINT: `${PREFIX}_print`,
};

// 对齐
const ALIGN_MENU = [
    ActionType.ALIGN_HORIZONTALLT_LEFT,
    ActionType.ALIGN_HORIZONTALLT_CENTER,
    ActionType.ALIGN_HORIZONTALLT_RIGHT,
    DIVIDER,
    ActionType.ALIGN_VERTICALLY_TOP,
    ActionType.ALIGN_VERTICALLY_CENTER,
    ActionType.ALIGN_VERTICALLY_BOTTOM,
    DIVIDER,
    ActionType.ALIGN_DISTRIBUTE_HORIZONTALLT,
    ActionType.ALIGN_DISTRIBUTE_VERTICALLY,
];

// 插入图表
export const INSERT_CHART = {
    key: `${ActionType.INSERT_CHART}`,
    items: [
        {
            key: `${ActionType.INSERT_CHART}-col`,
            items: [
                chartConfig.COLUMN_CLUSTERED_CHART_CONFIG.id,
                chartConfig.COLUMN_STACKED_CHART_CONFIG.id,
                chartConfig.COLUMN_PERCENT_STACKED_CHART_CONFIG.id,
            ],
        },
        {
            key: `${ActionType.INSERT_CHART}-line`,
            items: [
                chartConfig.LINE_STANDARD_CHART_CONFIG.id,
                chartConfig.LINE_STACKED_CHART_CONFIG.id,
                chartConfig.LINE_PERCENT_STACKED_CHART_CONFIG.id,
                chartConfig.LINE_STANDARD_CHART_WITH_POINT_CONFIG.id,
                chartConfig.LINE_STACKED_CHART_WITH_POINT_CONFIG.id,
                chartConfig.LINE_PERCENT_STACKED_CHART_WITH_POINT_CONFIG.id,
            ],
        },
        {
            key: `${ActionType.INSERT_CHART}-bar`,
            items: [
                chartConfig.BAR_CLUSTERED_CHART_CONFIG.id,
                chartConfig.BAR_STACKED_CHART_CONFIG.id,
                chartConfig.BAR_PERCENT_STACKED_CHART_CONFIG.id,
            ],
        },
        {
            key: `${ActionType.INSERT_CHART}-pie`,
            items: [
                chartConfig.PIE_CHART_CONFIG.id,
                chartConfig.OF_PIE_CHART_CONFIG.id,
                chartConfig.OF_PIE_BAR_CHART_CONFIG.id,
                chartConfig.DOUGHNUT_CHART_CONFIG.id,
            ],
        },
        {
            key: `${ActionType.INSERT_CHART}-area`,
            items: [
                chartConfig.AREA_CHART_CONFIG.id,
                chartConfig.AREA_STACKED_CHART_CONFIG.id,
                chartConfig.AREA_PERCENT_STACKED_CHART_CONFIG.id,
            ],
        },
        {
            key: `${ActionType.INSERT_CHART}-radar`,
            items: [
                chartConfig.RADAR_CHART_CONFIG.id,
                chartConfig.RADAR_WITH_POINT_CHART_CONFIG.id,
                chartConfig.RADAR_WITH_FILL_CHART_CONFIG.id,
            ],
        },
    ],
};

// 插入下拉
export const COMMON_INSERT_LIST = [
    ActionType.AI_GENERATE_PAGE,
    ActionType.INSERT_TEXT,
    {
        key: `${ActionType.INSERT_SHAPE}-parent`,
        items: [
            `${ActionType.INSERT_SHAPE}-parent-custom`,
        ],
    },
    ActionType.INSERT_LAYOUT,
    {
        key: ActionType.INSERT_PLACEHOLDER,
        items: [
            ActionType.INSERT_PLACEHOLDER_HORZ_CONTENT,
            ActionType.INSERT_PLACEHOLDER_VERT_CONTENT,
            ActionType.INSERT_PLACEHOLDER_HORZ_TEXT,
            ActionType.INSERT_PLACEHOLDER_VERT_TEXT,
            ActionType.INSERT_PLACEHOLDER_PICTURE,
            ActionType.INSERT_PLACEHOLDER_TABLE,
        ],
    },
    {
        key: ActionType.INSERT_PICTURE,
        items: [
            insertPictureConfig.FROM_LOCAL.id,
            insertPictureConfig.FROM_TENCENT_DOCS.id,
        ],
    },
    {
        key: ActionType.INSERT_AUDIO,
        items: [
            insertAudioConfig.FROM_LOCAL.id,
            insertAudioConfig.FROM_TENCENT_DOCS.id,
        ],
    },
    {
        key: ActionType.INSERT_VIDEO,
        items: [
            insertVideoConfig.FROM_LOCAL.id,
            insertVideoConfig.FROM_TENCENT_DOCS.id,
        ],
    },
    {
        key: `${ActionType.INSERT_FORM}-parent`,
        items: [
            `${ActionType.INSERT_FORM}-parent-custom`,
        ],
    },
    ActionType.INSERT_WITH_LINK,
    ActionType.INSERT_SLIDE_FOOTER,
    INSERT_CHART,
];

// 图片下拉
const IMAGE_LIST = [
    ActionType.TAILOR_PIC_NORMAL,
    {
        key: `${ActionType.INSERT_SHAPE}-parent-crop`,
        items: [
            ActionType.TAILOR_PIC_SHAPE,
        ],
    },
    {
        key: ActionType.TAILOR_PIC_WH,
        items: [
            ActionType.TAILOR_PIC_WH_1_1,
            DIVIDER,
            ActionType.TAILOR_PIC_WH_2_3,
            ActionType.TAILOR_PIC_WH_3_4,
            ActionType.TAILOR_PIC_WH_3_5,
            ActionType.TAILOR_PIC_WH_4_5,
            DIVIDER,
            ActionType.TAILOR_PIC_WH_3_2,
            ActionType.TAILOR_PIC_WH_4_3,
            ActionType.TAILOR_PIC_WH_5_3,
            ActionType.TAILOR_PIC_WH_5_4,
            ActionType.TAILOR_PIC_WH_16_9,
            ActionType.TAILOR_PIC_WH_16_10,
        ],
    },
];

// 调整slide百分比大小下拉
export const ADJUST_SLIDE_LIST = [
    ActionType.ADJUST_SLIDE_50,
    ActionType.ADJUST_SLIDE_75,
    ActionType.ADJUST_SLIDE_100,
    ActionType.ADJUST_SLIDE_125,
    ActionType.ADJUST_SLIDE_150,
    ActionType.ADJUST_SLIDE_200,
    ActionType.ADJUST_SLIDE_300,
    ActionType.ADJUST_SLIDE_400,
];

// 通用workbench菜单项
export const COMMON_MENU_SCHEMA: WorkbenchMenuSchema = [
    // 插入占位符(模板编辑)
    {
        key: ActionType.INSERT_PLACEHOLDER,
        items: [
            ActionType.INSERT_PLACEHOLDER_HORZ_CONTENT,
            ActionType.INSERT_PLACEHOLDER_VERT_CONTENT,
            ActionType.INSERT_PLACEHOLDER_HORZ_TEXT,
            ActionType.INSERT_PLACEHOLDER_VERT_TEXT,
            ActionType.INSERT_PLACEHOLDER_PICTURE,
            ActionType.INSERT_PLACEHOLDER_TABLE,
        ],
    },
    {
        key: wrapIdForBig(ChildActionType.ALIGN),
        items: ALIGN_MENU,
    },
    // 排列对齐
    {
        key: ActionType.MOVE_ITEM,
        items: [
            ActionType.MOVEUP,
            ActionType.MOVETOP,
            ActionType.MOVEDOWN,
            ActionType.MOVEBOTTOM,
            ActionType.SELECT_WINDOW,
            {
                key: ChildActionType.ALIGN,
                items: ALIGN_MENU,
            },
        ],
    },
    // 组合
    {
        key: ActionType.GROUP,
        items: [
            ActionType.ADDGROUP,
            ActionType.REMOVEGROUP,
        ],
    },
    // 页面设置
    {
        key: ActionType.PAGE_SETTING,
        items: [
            ActionType.CHANGE_BG,
            {
                key: ActionType.SLIDE_SIZE,
                items: [
                    ActionType.SLIDE_STANDARD,
                    ActionType.SLIDE_WIDE,
                    ActionType.SLIDE_CUSTOM,
                ],
            },
            ActionType.MASTER_LAYOUT,
        ],
    },
    // 图片裁剪
    {
        key: ActionType.TAILOR_PIC,
        items: IMAGE_LIST,
    },
    {
        key: wrapIdForBig(ActionType.TAILOR_PIC),
        items: IMAGE_LIST,
    },
    // 单双栏切换
    {
        key: ActionType.TOOLBAR_MODE,
        items: [
            ToolbarType.SINGLE_TOOLBAR,
            ToolbarType.DOUBLE_TOOLBAR,
            DIVIDER,
            IMMERSIVE_TOGGLE,
        ],
    },
    // 插入表格
    {
        key: `${ActionType.INSERT_FORM}-parent`,
        items: [`${ActionType.INSERT_FORM}-parent-custom`],
    },
    // 更改画布尺寸
    {
        key: ActionType.SLIDE_SIZE_TOOLBAR,
        items: [
            ActionType.SLIDE_STANDARD,
            ActionType.SLIDE_WIDE,
            ActionType.SLIDE_CUSTOM,
        ],
    },
    // 更改画布比例
    {
        key: ActionType.ADJUST_SLIDE,
        items: ADJUST_SLIDE_LIST,
    },
    // 动画开始方式
    {
        key: ActionType.ANIM_START,
        items: [
            ActionType.CLICK_EFFECT,
            ActionType.WITH_EFFECT,
            ActionType.AFTER_EFFECT,
        ],
    },
];
